import React, { useState } from 'react';
// import UserContext from 'contexts/UserContext';

import Course from 'containers/Administrator/Users/Create_Old/Student/Courses/Course';
import Add from 'containers/Administrator/Users/Create_Old/Student/Courses/Add';
import Blanks from 'containers/Administrator/Users/Create_Old/Student/Blanks';

import Button from 'components/Button';
import Icon from 'components/Icon';

const Courses = ({ gradeId, courses }) => {
	// Use user's context
	// const { handleUser } = useContext(UserContext);

	// Store modal's visibility
	const [courseModal, setCourseModal] = useState(false);
	const [blankModal, setBlankModal] = useState(false);

	// Toggle modal's visibility
	const handleCourseModal = () => setCourseModal(m => !m);
	const handleBlankModal = () => setBlankModal(m => !m);

	// Handle course sorting
	// const onSort = ({ oldIndex, newIndex }) => {
	// 	handleUser({
	// 		type: 'ON_SORT_COURSE_STUDENT',
	// 		payload: {
	// 			gradeId,
	// 			old: oldIndex,
	// 			new: newIndex
	// 		}
	// 	});
	// };

	return (
		<>
			<h5>Moduļi ({courses?.length})</h5>

			{/* Student's grade courses */}
			{!!courses.length && <div className="studentCourses studentCourses--selected withMarginTop">
				{courses.map(course =>
					<Course key={course.id} gradeId={gradeId} course={course} />
				)}
			</div>}
			
			{/* Toggle blank selection modal */}
			{courses.length === 0 && <div className="addBlock withMarginTop" onClick={handleBlankModal}>
				<Icon icon="folder_special" size="lg" className="addBlock__icon" />
				<div className="addBlock__title">Pievienot sagatavi</div>
				<div className="addBlock__description">Piesaistiet kursus izvēloties sagatavi</div>
			</div>}

			{/* Toggle course selection modal */}
			<Button
				block
				icon="add"
				theme="light"
				text="Pievienot moduli"
				className="withMarginTop"
				onClick={handleCourseModal}
			/>

			{/* Course selection modal */}
			<Add gradeId={gradeId} modal={courseModal} handleModal={handleCourseModal} />

			{/* Blank selection modal */}
			<Blanks gradeId={gradeId} modal={blankModal} handleModal={handleBlankModal} />
		</>
	);
};

export default Courses;